import actions from './actions'

export default function WorkOrderTypesReducer(state = { loading: false }, action) {
  switch (action.type) {
    case actions.REQUESTING:
      return {
        ...state,
        loading: true,
        editing: null,
        saveSuccess: false,
      }
    case actions.LIST_WORKORDERTYPE:
      return {
        ...state,
        result: action.result,
        loading: false,
        saveSuccess: false,
      }
    case actions.EDIT_WORKORDERTYPE:
      return {
        ...state,
        editing: action.result,
        loading: false,
        saveSuccess: false,
      }
    case actions.RESET_WORKORDERTYPE:
      return {
        ...state,
        editing: null,
        loading: false,
        saveSuccess: false,
      }
    case actions.NEW_WORKORDERTYPE:
      return {
        ...state,
        editing: { typeID: 0 },
        loading: false,
        saveSuccess: false,
      }
    case actions.CREATE_WORKORDERTYPE_RECIEVED ||
      actions.UPDATE_WORKORDERTYPE_RECIEVED ||
      actions.DELETE_WORKORDERTYPE_RECIEVED:
      return {
        ...state,
        editing: { typeID: 0 },
        loading: false,
        saveSuccess: true, // mark
      }
    case actions.RESPONSE_ERROR:
      return {
        ...state,
        loading: false,
        error: true,
        saveSuccess: false,
        message: action.message,
      }
    default:
      return state
  }
}
